// extracted by mini-css-extract-plugin
module.exports = {"container":"AddNewUsersButton_container__22R18","addNewUserIcon":"AddNewUsersButton_addNewUserIcon__2AuVY","addNewUserText":"AddNewUsersButton_addNewUserText__Pbn3A"};